export default __webpack_public_path__ + "static/media/card1.de3b2738.png";